import dayjs from "dayjs";
import { FC, ReactNode } from "react";

import { useCurrentAccount } from "src/entities/account/useCurrentAccount";
import { useFetchReceptionHomeQuery } from "src/hooks/useReceptionHome/document.gen";

export const ReceptionTimeSlotsProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { currentAccount } = useCurrentAccount();

  useFetchReceptionHomeQuery(
    currentAccount && currentAccount.currentClinic.receptionAvailable
      ? {
          pollInterval: 30000,
          fetchPolicy: "network-only",
          variables: {
            date: dayjs().format("YYYY-MM-DD"),
            standbyActionRequired: true,
          },
        }
      : { skip: true },
  );

  return <>{children}</>;
};
